import React, { useState, useEffect } from 'react';
import OnboardingChatbot from './OnboardingChatbot';
import './SignupSuccess.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const SignupSuccess = () => {
  const [showChatbot, setShowChatbot] = useState(false);
  const [skipped, setSkipped] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Ensure page starts scrolled to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to show the chatbot when button is clicked
  const handleShowChatbot = () => {
    setShowChatbot(true);
  };

  const handleSkip = async () => {
    setSkipped(true);
    if (currentUser) {
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userRef, {
          onboardingSkipped: true
        });
      } catch (error) {
        console.error("Error updating user document:", error);
      }
    }
    navigate('/home');
  };

  return (
    <div className="signup-success-container">
      <div className="signup-success-content">
        <h1><strong>Welcome to Shabbat Abroad!</strong></h1>
        <p>Your account is all set 🎉</p>
        <p>Want to make your dinner extra special?</p>
        <p>Click below to start a quick chat with <span className="super-strong">Shabbot</span>, our friendly Q&A bot. It'll help personalize your profile and suggest fun conversation starters and activities.</p>
        <p>Totally optional - and you can always change your answers later in your profile settings.</p>
        {!showChatbot && !skipped && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
            <button onClick={handleShowChatbot} className="to-chat-button">
              To the chat
            </button>
            <span
              className="skip-stage-link"
              onClick={handleSkip}
              style={{
                color: '#ff914d',
                marginTop: 12,
                fontWeight: 500,
                fontSize: '1em',
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseOver={e => e.currentTarget.style.textDecoration = 'underline'}
              onMouseOut={e => e.currentTarget.style.textDecoration = 'none'}
            >
              Skip this stage for now, I'll get to it later.
            </span>
          </div>
        )}
        {skipped && (
          <div style={{ color: '#888', marginTop: 20, fontWeight: 500, fontSize: '1.1em', textAlign: 'center' }}>
            You can always chat with Shabbot later from your profile settings!
          </div>
        )}
      </div>
      {showChatbot && <OnboardingChatbot onClose={() => setShowChatbot(false)} />}
    </div>
  );
};

export default SignupSuccess; 